import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiSection from "../foto-multi-section/FotoMultiSection";
import EsempiDannoVeicolo from "./EsempiDannoVeicolo";
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

/* istanbul ignore next */
const FotoDannoCtpVeicolo = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoDanniCtpList, setFotoDanniCtpList] = useState<FileItemType[]>(communication.fotoDanniCtpList)
    return (
        <>
            <EsempiDannoVeicolo />
            <FotoMultiSection
                fileType={PhotoTypeEnum.DANNO_VEICOLO_CTP_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.DANNO_VEICOLO_CTP_DOCS],
                    liqDescription: "altro"
                }}
                files={fotoDanniCtpList}
                setFiles={setFotoDanniCtpList}
                arrayDbPropSync={"fotoDanniCtpList"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto danno"}
                minPhotoNumber={3}
            />
        </>
    )
}

export default FotoDannoCtpVeicolo